module.exports = "<div class=\"js-container\"></div>";